import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { BottomSheet } from '../bottom.sheet';

@Component({
  selector: 'app-view-items',
  templateUrl: './view-items.component.html',
  styleUrls: ['./view-items.component.scss'],
})
export class ViewItemsComponent  {
  loader: boolean = false;
  custitem:any=[];
  change:boolean = true;
  custSubscriptions:any=[];
  custSubscriptionsName;
  name;
  details;
  identificationNo;
  model;
  viewBtns:boolean;
  users:any=[];Name;UserId;
  id;
  category;
  cateName;
  url;
  Oid;
  clickId;
  cateId;
  constructor( private router: Router, private bottomSheet: MatBottomSheet,  public handler: HandlerService, private platform: Platform,
    public service: ApiService) { }

  ionViewWillEnter(){ 
    this.viewBtns= false;
    this.loader=true;
    this.url = window.location.href;
    this.id = this.url.split('/').pop();
    sessionStorage.setItem('customerId',this.id)
    this.getCategory();
    }

    openBooking(id,data){
      this.router.navigate(['single-booking/' + id]);
      sessionStorage.setItem('custItemId', data.id);
      sessionStorage.setItem('itemCategoryId',data.itemCategoryId);
    }

    openSubsBooking(id,data){
      this.router.navigate(['cust-subs-booking/' + id]);
      sessionStorage.setItem('custItemId', data.id);
      sessionStorage.setItem('itemCategoryId',data.itemCategoryId);
    }


    getUserId(){ 
      this.service.getUserById(this.id).subscribe((res:any)=>{
        this.details=res;
        this.Oid = res.orgId;
       this.custitem=res.custItems;      
          this.custitem.map(res=>{
          this.category.map(res1 => {     
            if (res1.id == res.itemCategoryId) {
              this.cateName = res1.name;
              this.cateId = res1.id;
            }
          })
          })
     
         this.loader=false;
      },err =>{
        this.handler.err(err)
    
      })
    }

    getCategory(){
      this.service.getOrgCategory().subscribe((res: any) => {
        this.category=res; 
       this.getUserId();
      })
    } 



  getModel(data){
    if(data.custItems){
      if(data.custItems[0]){
        return data.custItems[0].model
      }
    }
  }

  getId(data){
    if(data.custItems){
      if(data.custItems[0]){
        return data.custItems[0].identificationNo
      }
    }
  }


  
  route(id){   
    this.router.navigate(['cust-item-edit/', +id]);
  }

 

  deleteItem(id){
    this.loader=true;
    this.service.deleteCustItem(id).subscribe(res=>{
      this.loader=false;
      this.handler.res("Deleted successfully")
    this.ionViewWillEnter();
    },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  }

  // deleteSubscription(id){
  //   this.loader=true;
  //   this.viewBtns = false;
  //   this.service.cancelReq(id).subscribe((res: any) => {
  //     this.handler.res("Cancelled successfully");
  //     this.loader=false;
  //   this.ionViewWillEnter();
  //   },
  //   err=>{
  //     this.handler.err(err)
  //     this.loader=false
  //   })  
  // }


     
  openBottomSheet(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.users,
    });
    dialogRef.afterDismissed().subscribe(res => {
      if(res){
        this.Name = res.firstName;
        this.UserId=res.userId;
      }
    });
  }  

  vendorAssign(id,item){
    this.viewBtns=false;
    this.router.navigate(['/assignVendor/', +id]);
    window['appointmentObj'] = item;
  }
  enableButton(x){
    if(this.clickId==x.id){
      this.clickId="";
    }else{
      this.clickId=x.id
    }
  }
}
